<template>
    <div class="promotion-allocation-area__data" :class="colourClass">
        <main-expand-button
            :is-expanded="isExpanded"
            :promotion-id="params.data._id"
            size="small"
        />
    </div>
</template>

<script>
import promotionCellRendererMixin from './promotion-cell-renderer-mixin';

export default {
    name: 'PromotionExpandButtonRenderer',
    mixins: [promotionCellRendererMixin],
    computed: {
        isExpanded() {
            return this.params.isSelected(this.params.data);
        },
    },
};
</script>
